<template>
    <div>
        <div :gutter="10" v-for="productGroup in groupedProducts" :key="productGroup.type_id" style="line-height: 20px;">
            <el-checkbox :indeterminate="productGroup.isIndeterminate" v-model="productGroup.checkAll" @change="handleCheckAllChange(productGroup)">{{ productGroup.type_name }}</el-checkbox>
            <el-checkbox-group v-model="productGroup.checkedCities" @change="handleCheckedCitiesChange(productGroup)" style="margin-left: 40px;line-height: 20px;">
                <el-checkbox v-for="product in productGroup.products" :label="product.id" :key="product.id">{{ product.name }}</el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import CommonService from "~/services/common";
    export default {
        name: "ProductType",

        components: {
        },

        props: {
            productCheckedIds: {
                type: Array,
            },
        },

        data() {
            return {
                groupedProducts: [],
                productList: [],
                productChecked: [],
            };
        },

        mounted() {

        },

        created: function () {
            this.productChecked = this.productCheckedIds.map(function (str) {
                return parseInt(str);
            });
            this.getProducts();
        },

        methods: {

            getProducts(){
                CommonService.getProducts({
                    status: 1,
                    is_deleted: 0,
                    fields: 'id,name,price,code,allow_config,memo,type_id,type_name',
                    expand: 'start_at,end_at,disabled',
                    scenary: 'show-all'
                }).then(res => {
                    this.productList = res.data
                    this.setGroupedProducts();
                    console.log('页面加载完毕', this.productList);
                });
            },

            setGroupedProducts() {
                let grouped = {};

                if (!this.productList) {
                    return [];
                }

                this.productList.forEach((product) => {
                    const type_name = product.type_name || '未分类';
                    if (!grouped[type_name]) {
                        grouped[type_name] = {
                            type_id: product.type_id,
                            type_name,
                            products: [],
                            checkAll: false,
                            checkedCities: [],
                        };
                    }
                    if(this.productChecked.includes(product.id)){
                        grouped[type_name].checkedCities.push(product.id);
                    }
                    grouped[type_name].products.push(product);
                });

                let groupsArray = Object.values(grouped).map((group) => {
                    group.isIndeterminate = group.checkedCities.length > 0 && group.checkedCities.length < group.products.length;
                    group.checkAll = group.checkedCities.length === group.products.length;
                    return group;
                });

                groupsArray.sort((a, b) => {
                    const type_idA = typeof a.type_id === 'string' ? a.type_id : String(a.type_id);
                    const type_idB = typeof b.type_id === 'string' ? b.type_id : String(b.type_id);
                    return type_idA.localeCompare(type_idB);
                });
                this.groupedProducts = groupsArray;
                console.log('返回数据：', grouped, this.groupedProducts);
            },

            handleCheckedCitiesChange(productGroup) {
                productGroup.isIndeterminate = productGroup.checkedCities.length > 0 && productGroup.checkedCities.length < productGroup.products.length;
                productGroup.checkAll = productGroup.checkedCities.length === productGroup.products.length;
                
                productGroup.products.forEach(item => {
                    if(!productGroup.checkedCities.includes(item.id)){
                        this.productChecked = this.productChecked.filter(product_id => product_id !== item.id);
                    }else if(!this.productChecked.includes(item.id)){
                        this.productChecked.push(item.id);
                    }
                });
                console.log('点击单个：', productGroup, this.productChecked);
                this.$emit("change", this.productChecked); 
            },

            handleCheckAllChange(productGroup) {
                productGroup.checkedCities = productGroup.checkAll ? productGroup.products.map(product => product.id) : [];
                //全部选中
                if(productGroup.checkAll){
                    productGroup.checkedCities.forEach(product_id => {
                        if(!this.productChecked.includes(product_id)){
                            this.productChecked.push(product_id)
                        }
                    });
                }else{
                    productGroup.products.forEach(item => {
                        this.productChecked = this.productChecked.filter(product_id => product_id !== item.id);
                    });
                }
                console.log('点击全选：', productGroup, this.productChecked);
                this.$emit("change", this.productChecked); 
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/widgets/ProductType.vue